/* eslint-disable react/prefer-stateless-function */
/* eslint-disable no-useless-constructor */
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Gallery from '../gallery/Gallery';
import { GetActivePage } from '../../redux/helpers';
import { getBackgrounsByLayoutType } from '../../redux/helpers/layouts';


class GalleryContainer extends Component {
  constructor(...args) {
    super(...args);
  }

  render() {
    const {
      backgrounds, pages, layouts, hasParent,
    } = this.props;
    const currentPage = GetActivePage(pages);

    if (!currentPage) {
      return null;
    }

    const { backgroundImages } = currentPage;


    let items = [];
    if (backgrounds) {
      const getBackground = getBackgrounsByLayoutType(pages, layouts, backgrounds);
      if (getBackground) {
        const get = Object.values(getBackground).find(el => el.name === backgroundImages.type);
        items = get ? get.items : items;
      }
    }
    return (
      <Gallery hasParent={hasParent} currentPage={currentPage} images={items} />
    );
  }
}

GalleryContainer.defaultProps = {

  pages: {},
  layouts: {},

};

GalleryContainer.propTypes = {

  pages: PropTypes.object,
  layouts: PropTypes.object,

};

export default connect(state => ({
  backgrounds: state.backgrounds.backgrounds,
  pages: state.entities.pages.byId,
  layouts: state.entities.layouts.byId,
  hasParent: state.bookProperties.parentStyle,
}))(GalleryContainer);



// WEBPACK FOOTER //
// ./src/components/gallery-container/GalleryContainer.jsx